// copy of packages/integrations/databricks/shared/src/constants.ts, with AWS
// alone, since the Databricks (AI) connector accepts no other cloud

/** The integration's key: its registry key, and the type of its requests. */
export const DATABRICKS_AI_INTEGRATION_KEY = "databricks-ai" as const;

/**
 * The connector's Lambda function name, which is also its image name. The
 * install Terraform deploys the connector under it, and P0 invokes it by it.
 */
export const DATABRICKS_AI_CONNECTOR_FUNCTION_NAME =
  "p0-connector-databricks-ai";

/**
 * The Databricks account consoles P0 accepts: the AWS one alone.
 *
 * The connector only accepts these (`DATABRICKS_HOSTS` in
 * p0-connector-databricks-ai), because it sends its AWS identity token to
 * whichever console a request names. They are repeated here because the
 * connector package can't be bundled into the frontend.
 */
export const DatabricksAccountsUrls = [
  "https://accounts.cloud.databricks.com", // AWS
] as const;

/**
 * The domain each account console's workspaces are served from. A workspace's
 * URL is `https://<host>` on its account's domain.
 *
 * The connector sends the service principal's Databricks token to a
 * workspace's URL, so it only accepts a host on one of these
 * (`DATABRICKS_HOSTS` in p0-connector-databricks-ai). They are repeated here
 * for the same reason as {@link DatabricksAccountsUrls}.
 */
export const DatabricksWorkspaceDomains = {
  "https://accounts.cloud.databricks.com": "cloud.databricks.com",
} as const satisfies Record<(typeof DatabricksAccountsUrls)[number], string>;

/**
 * The Unity Gateway MCP service each Databricks server fronts, by the
 * server's `definition.id`. Stage accepts a request only through one of
 * these servers.
 */
export const DatabricksAiMcpServices = {
  databricksGenie: "system.ai.genie_one_mcp",
  databricksSql: "system.ai.dbsql",
} as const;

/**
 * The `aud` the connector requests its AWS identity tokens with
 * (`DATABRICKS_TOKEN_AUDIENCE` in p0-connector-databricks-ai), which the
 * federation policy on P0's service principal must expect. Repeated here for
 * the same reason as {@link DatabricksAccountsUrls}.
 */
export const DATABRICKS_TOKEN_AUDIENCE = "databricks";
